export default "__VITE_ASSET__a18b2ab7__"